export default __webpack_public_path__ + "static/media/text_bubble_02.befba5bf.png";